import React from "react";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import ScienceHeader from "../../Components/Science/ScienceHeader/ScienceHeader";
import BrainWave from "../../Components/Science/BrainWave/BrainWave";
import Publications from "../../Components/Science/Publications/Publications";
import BrainCarousel from "../../Components/Science/BrainCarousel/BrainCarousel";
import ArtificialIntelligence from "../../Components/Science/ArtificialIntelligence/ArtificialIntelligence";

const Science = () => {
  return (
    <>
      <Header />
      <ScienceHeader />
      <ArtificialIntelligence />
      <BrainCarousel />
      <BrainWave />
      <Publications />
      <Footer />
    </>
  );
};

export default Science;
